/* eslint-disable */
import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import gsap from "gsap";
import { SplitText } from "gsap/SplitText";
import barba from "@barba/core";
import Flickity from "flickity";
import lottie from "lottie-web";

const HTML = document.querySelector("html");
let durationTabs = window.innerWidth > 992 ? 0.9 : 0;

gsap.registerPlugin(SplitText);

class App {
  constructor() {
    const _ = this;

    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest("figure");
          if (figure) figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure) figure.classList.add("img-is-loaded");
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    /** Toggle menu */
    const toggles = document.querySelectorAll(".toggle-menu");
    if (toggles) {
      toggles.forEach((toggle) => {
        toggle.addEventListener("click", (e) => {
          e.preventDefault();
          HTML.classList.toggle("open-menu");
        });
      });
    }

    this.container = document.querySelector(".main");

    /** FIRST STEP */
    /** Timeline init */
    const start = gsap.timeline({
      paused: true,
      onComplete: () => {},
    });
    const mainHeader = document.querySelector(".main-header");
    const links = document.querySelectorAll(".menu-link .inner");
    const { section } = this.container.dataset;
    start
      .to(mainHeader, {
        clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
        ease: "circ.inOut",
        onComplete: () => {
          HTML.classList.add("menu-is-show");
        },
      })
      .to(
        links,
        {
          stagger: 0.15,
          clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
          duration: 0.25,
          ease: "circ.inOut",
          onComplete: () => {
            window.scrollTo(0, 0);
            this.activeTabs();
          },
        },
        "-=0.2"
      )
      .to(document.querySelector(".main-content"), {
        delay: section != "none" ? durationTabs : 0,
        autoAlpha: 1,
        onStart: () => {
          this.mount();
        },
      });

    window.addEventListener("load", async () => {
      setTimeout(async () => {
        await start.play();
        this.asyncLoad();
        window.dispatchEvent(new Event("scroll"));
      }, 100);
    });
  }

  asyncLoad() {
    const _ = this;

    const logoTransition = document.querySelector('.logo-transition');

    barba.init({
      debug: false,
      views: [
        {
          namespace: "home",
          afterEnter() {
            if (typeof gtag !== "undefined") {
              gtag("event", "page_view", {
                page_title: document.title,
                page_location: location.href,
                page_path: location.pathname,
              });
            }
          },
        },
      ],
      prevent: ({ el, href }) => {
        // 1) Opt-out explicite
        if (el.classList.contains('ab-item')) return true;

        return false; // sinon, Barba gère
      },
      transitions: [
        {
          name: "default-transition",
          leave(data) {
            const isOpenMenu = HTML.classList.contains("open-menu");
            _.unmount();

            if( logoTransition && logoTransition.lottie ) {
              gsap.to(logoTransition, {
                autoAlpha: 1,
                duration: 0.2,
              })
              logoTransition.lottie.goToAndPlay(0);
            }

            return gsap.to(
              data.current.container.querySelector(".main-content"),
              {
                onComplete: () => {
                  window.scrollTo(0, 0);
                },
                delay: isOpenMenu ? 0.4 : 0,
                duration: 0.2,
                opacity: 0,
              }
            );
          },
          enter(data) {
            gsap.set(data.current.container, {
              position: "absolute",
              top: 0,
              left: 0,
            });
            _.container = data.next.container;
            _.activeTabs();
            const mainContent =
              data.next.container.querySelector(".main-content");

            const nextHTML = document.createElement('div')
            nextHTML.innerHTML = data.next.html;

            /* Lang selector */
            const langSelector = document.querySelector('.container-lang-selector');
            const nextLangSelector = nextHTML.querySelector('.lang-selector');
            if( nextLangSelector ) {
              const hasSelector = langSelector.querySelector('.lang-selector');
              langSelector.innerHTML = '';
              langSelector.append(nextHTML.querySelector('.lang-selector'));

              if( !hasSelector ) {
                gsap.set(nextLangSelector, {autoAlpha:0} );
                gsap.to(langSelector.querySelector('.lang-selector')
                , {
                    autoAlpha: 1,
                    delay: 0.2,
                    duration: 0.3
                  }
                )
              }
            } else {
              gsap.to(
                langSelector.querySelector('.lang-selector')
                , {
                  autoAlpha: 0
                }
              )
            }


            /** Background color for mobile */
            document.documentElement.style.setProperty(
              "--current-section",
              data.next.container.dataset.color
            );

            return gsap.to(mainContent, {
              opacity: 1,
              delay: durationTabs,
              onStart: () => {

                if( logoTransition && logoTransition.lottie ) {
                  gsap.to(logoTransition, {
                    autoAlpha: 0,
                    duration: 0.2,
                    onComplete : () => {
                      logoTransition.lottie.stop();
                    }
                  })
                }
                _.mount();
                // setTimeout(() => {
                // }, durationTabs * 1000 * 0.3);
              }
            });
          },
        },
      ],
    });
  }

  activeTabs() {
    const { section } = this.container.dataset;
    const menuLinks = document.querySelectorAll(`.menu-link`);
    let nextSlug = -1;

    menuLinks.forEach((link, i) => {
      link.classList.remove("active");
      if (link.dataset.slug == section) nextSlug = i;
    });

    if (nextSlug >= 0) {
      menuLinks[nextSlug].classList.add("active");
    }

    // On positionne le contenu
    if (window.innerWidth > 992) {
      gsap.set(this.container, {
        left: `calc(var(--widthTabs) * ${
          nextSlug >= 0 ? nextSlug : menuLinks.length
        })`,
      });
    }
  }

  unmount() {
    HTML.classList.remove("open-menu");
  }

  mount() {
    this.lazyload.update();
    this.bodymovin();
    this.clamp();
    this.map();
    this.slider();
    this.revealLine();
    this.accordion();
    this.marquee();
    this.filters();
    this.eventsList();
    this.accordionImgs();
    this.inViewport();
  }

  clamp() {
    const elts = document.querySelectorAll('[data-clamp]');

    if( elts ) {
      elts.forEach(el => {
        const content = el.querySelector('.content');
        const trigger = el.querySelector('.trigger');

        if( trigger && content ) {
          content.height = content.clientHeight;

          trigger.addEventListener('click', (e) => {
            e.preventDefault();

            el.classList.toggle('open');

            gsap.to(content, {
              height : el.classList.contains('open') ? content.scrollHeight  : content.height,
              duration: 0.3,
              ease: 'circ.inOut'
            })
          })
        }
      })
    }
  }

  accordion() {
    const elts = document.querySelectorAll(".accordion");

    if (elts) {
      elts.forEach((el) => {
        const headers = el.querySelectorAll(".accordion-header");
        const items = el.querySelectorAll(".accordion-item");
        const contents = el.querySelectorAll(".accordion-content");

        if (headers && contents) {
          headers.forEach((trigger, i) => {
            trigger.addEventListener("click", (e) => {
              e.preventDefault();

              items[i].classList.toggle("active");

              const active = items[i].classList.contains("active");

              gsap.to(contents[i], {
                autoAlpha: active ? 1 : 0,
                height: active ? contents[i].children[0].offsetHeight : 0,
                ease: "circ.inOut",
                duration: 0.3,
              });
            });
          });
        }
      });
    }
  }

  slider() {
    const elts = document.querySelectorAll(".slider");

    if (elts) {
      elts.forEach((el) => {

        // On prepare l'animation lottie
        let transition = false;
        const canvas = el.querySelector(".canvas");
        if (canvas) {
          transition = lottie.loadAnimation({
            container: canvas,
            renderer: "svg",
            loop: false,
            autoplay: false,
            path: canvas.dataset.lottie,
            rendererSettings: {
              preserveAspectRatio: "xMinYMin slice"
            } 
          });
        }

        new Flickity(el, {
          cellSelector: '.item',
          autoPlay: el.dataset.autoplay && el.querySelectorAll('.item').length > 1
            ? Number.parseFloat(el.dataset.autoplay)
            : false,
          pauseAutoPlayOnHover: true,
          wrapAround: true,
          pageDots: false,
          on: {
            select: () => {
              if (transition) {
                
                transition.goToAndPlay(0);
              }
            }
          },
        });
      });
    }
  }

  map() {
    const elts = document.querySelectorAll(".map-container");

    if (elts) {
      elts.forEach((el) => {
        const map = el.querySelector("svg.map");
        const filters = el.querySelectorAll("[data-map]");

        if (!map) return;

        const areas = map.querySelectorAll(".area");

        function goto(value) {
          areas.forEach((area) => {
            if (area.classList.contains(value) || value == "") {
              // On met en surbrillance les zones (remplissage et bordure)
              gsap.to(area.querySelectorAll(".shape"), {
                fill: area.dataset.color,
                stroke: "#000",
                duration: 0.3,
              });

              // On remets les espaces de la zone en etat initial
              gsap.to(area.querySelectorAll('[stroke-dasharray="2"]'), {
                stroke: "#1A1A1A",
                duration: 0.3,
              });
            } else {
              // Les zones non sélectionnées deviennent noir
              gsap.to(area.querySelectorAll(".shape"), {
                fill: "#EDEDED",
                stroke: area.dataset.color,
                duration: 0.3,
              });

              // Et les espaces à la couleur d'origine de la zone
              gsap.to(area.querySelectorAll('[stroke-dasharray="2"]'), {
                stroke: area.dataset.color,
                duration: 0.3,
              });
            }
          });
        }

        if (filters) {
          filters.forEach((filter) => {
            filter.addEventListener("click", (e) => {
              e.preventDefault();
              filters.forEach((f) => f.classList.remove("active"));
              filter.classList.add("active");
              goto(filter.dataset.map);
            });

            if (filter.classList.contains("active")) {
              goto(filter.dataset.map);

              // filter.dispatchEvent(new Event("click"));
            } 
          });
        }

        const select = el.querySelector("select");
        if (select) {
          select.addEventListener("change", () => {
            goto(select.value);
          });
        }
      });
    }
  }

  bodymovin() {
    const tags = document.querySelectorAll("[data-bodymovin]");

    if (tags) {
      tags.forEach((tag) => {
        tag.addEventListener("inview", () => {
          if (!tag.classList.contains("loaded")) {
            const anim = tag.dataset.bodymovin;
            // const path = `${WPTEMPLATE}/static/bodymovin/${anim}/data.json`;
            fetch(anim).then((response) => {
              if (response.status == 200) {
                const l = lottie.loadAnimation({
                  container: tag,
                  renderer: "svg",
                  loop: tag.dataset.loop == 'false' ? false : true,
                  autoplay: tag.dataset.autoplay == 'false' ? false : true,
                  path: anim,
                });
                tag.classList.add("loaded");
                tag.lottie = l;
              }
            });
          } else if (tag.lottie) {
            tag.lottie.play();
          }
        });

        tag.addEventListener("outview", () => {
          if (tag.lottie) {
            // tag.lottie.pause();
          }
        });
      });
    }
  }

  marquee() {
    const elts = document.querySelectorAll(".marquee:not(.ready)");

    if (elts) {
      elts.forEach((el) => {
        el.classList.add("ready");
        const line = el.querySelector(".line");

        let scrollDirection = Number(el.dataset.dir ? el.dataset.dir : 1); // 1 = gauche, -1 = droite
        const speed = 40; // Pixels par seconde

        // Duplique les images pour un effet continu
        const images = line.innerHTML;
        line.innerHTML += images;
        this.lazyload.update();

        // Calcule la largeur totale de la marquee
        const marqueeWidth = line.scrollWidth / 2;

        // Initialise la position
        let position = 0;

        let cursor = 0;

        // Animation continue
        const animate = (timestamp) => {
          position += (speed / 100) * -scrollDirection; // Ajuste selon la vitesse et direction

          // Réinitialise la position si elle dépasse la largeur totale
          if (position <= -marqueeWidth) {
            position = 0;
          } else if (position >= 0) {
            position = -marqueeWidth;
          }

          line.style.transform = `translateX(${position}px)`;
          cursor = requestAnimationFrame(animate);
        };

        // Écouteur pour changer la direction en fonction du scroll
        let lastScrollY = window.scrollY;
        window.addEventListener("scroll", () => {
          const currentScrollY = window.scrollY;
          if (currentScrollY > lastScrollY) {
            scrollDirection = Number(el.dataset.dir ? el.dataset.dir : 1); // Scroll vers le bas : gauche
          } else if (currentScrollY < lastScrollY) {
            scrollDirection = -Number(el.dataset.dir ? el.dataset.dir : 1); // Scroll vers le haut : droite
          }
          lastScrollY = currentScrollY;
        });

        if (el.dataset.hover) {
          el.addEventListener("mouseenter", () => {
            cancelAnimationFrame(cursor);
          });
          el.addEventListener("mouseleave", () => {
            cursor = requestAnimationFrame(animate);
          });
        }

        // Lance l'animation
        cursor = requestAnimationFrame(animate);
      });
    }
  }

  filters() {
    const elts = document.querySelectorAll(".filter");

    if (elts) {
      elts.forEach((el) => {
        const selects = el.querySelectorAll("select");
        const filters = [];

        if (selects) {
          selects.forEach((select) => {
            select.addEventListener("change", () => {
              filters.forEach((filter, i) => {
                if (filter.slug == select.name) {
                  filters.splice(i, 1);
                }
              });
              if (select.value != "") {
                filters.push({
                  slug: select.name,
                  value: select.value,
                });
              }

              applyFilter();
            });
          });

          function applyFilter() {
            const eltsFilter = document.querySelectorAll("[data-filter]");
            const eltsParent = document.querySelectorAll(
              "[data-filter-parent]"
            );
            const eltsActive = [];

            eltsFilter.forEach((item) => {
              let isVisible = true;

              if (filters.length > 0) {
                const BreakException = {};

                try {
                  filters.forEach((filter) => {
                    if (!item.classList.contains(filter.value)) {
                      isVisible = false;
                      item.classList.remove("show");
                      throw BreakException;
                    }

                    item.classList.add("show");
                    eltsActive.push(item);
                  });
                } catch (e) {
                  if (e !== BreakException) throw e;
                }
              }

              gsap.to(item, {
                height: isVisible ? item.children[0].offsetHeight : 0,
                ease: "circ.inOut",
                duration: 0.4,
                onComplete: () => {
                  if (isVisible) gsap.set(item, { clearProps: "height" });
                },
              });
            });

            // On cache le parent si pas d'élément visible dedans
            if (eltsParent) {
              eltsParent.forEach((parent) => {
                const itemsChild = parent.querySelectorAll("[data-filter]");
                const childs = parent.querySelectorAll("[data-filter].show");

                const height = filters.length <= 0 ? 
                                  parent.scrollHeight + itemsChild.length * itemsChild[0].offsetHeight : 
                                  parent.querySelector("[data-filter]").children[0].offsetHeight *
                                    childs.length +
                                    parent.querySelector(".header-table").offsetHeight

                gsap.to(parent, {
                  height:
                    childs.length > 0 || filters.length <= 0
                      ?  height : 0,
                  onComplete: () => {
                    if (childs.length > 0 || filters.length <= 0)
                      gsap.set(parent, { clearProps: "height" });
                  },
                  ease: "circ.inOut",
                  duration: 0.4,
                });
              });
            }
          }
        }
      });
    }
  }

  eventsList() {
    const elts = document.querySelectorAll(".events-list");

    if (elts) {
      elts.forEach((el) => {
        const cursor = el.querySelector(".cursor-event");
        const items = el.querySelectorAll(".event-item");
        const timer = 0;

        if (items && cursor) {
          items.forEach((item) => {
            item.addEventListener("mouseenter", (e) => {
              if (item.dataset.thumb) {
                gsap.set(cursor, {
                  backgroundImage: `url(${item.dataset.thumb})`,
                });
              }

              gsap.set(cursor, {
                top: e.clientY,
                left: e.clientX,
              });

              clearTimeout(timer);

              gsap.to(cursor, {
                duration: 0.2,
                autoAlpha: 1,
                scale: 1,
                ease: "circ.inOut",
              });
            });

            item.addEventListener("mouseleave", (e) => {
              // timer = setTimeout(() => {
              gsap.to(cursor, {
                duration: 0.2,
                autoAlpha: 0,
                scale: 0.6,
                ease: "circ.inOut",
              });
              // }, 200);
            });

            item.addEventListener("mousemove", (e) => {
              gsap.set(cursor, {
                top: e.clientY,
                left: e.clientX,
              });
            });
          });
        }
      });
    }
  }

  accordionImgs() {
    const elts = document.querySelectorAll(".accordion-imgs");

    if (elts) {
      elts.forEach((el) => {
        const panels = el.querySelectorAll(".item");
        const ratio = panels.length > 6 ? 10 : 4;
        let delay = 0;

        panels.forEach((panel) => {
          panel.addEventListener("mouseenter", () => {
            // agrandit le panel survolé
            gsap.to(panels, {
              flex: 1, // tous reviennent à 1
              duration: 0.6,
              ease: "power3.out",
              delay,
            });
            gsap.to(panel, {
              flex: window.innerWidth > 992 ? ratio : 14, // celui survolé devient large
              duration: 0.6,
              delay,
              ease: "power3.out",
            });

            panel.classList.add("active");
          });

          const desc = panel.querySelector(".desc");
          const triggerDesc = panel.querySelector(".trigger-desc");

          panel.addEventListener("mouseleave", () => {
            panel.classList.remove("active");

            if (desc && panel.classList.contains("show")) {
              triggerDesc.dispatchEvent(new Event("click"));
            }
          });

          if (desc && triggerDesc) {
            triggerDesc.addEventListener("click", (e) => {
              e.preventDefault();

              panel.classList.toggle("show");

              gsap.to(desc, {
                duration: 0.3,
                ease: "circ.inOut",
                autoAlpha: panel.classList.contains("show") ? 1 : 0,
                height: panel.classList.contains("show")
                  ? desc.children[0].offsetHeight
                  : 0,
              });

              delay = panel.classList.contains("show") ? 0.3 : 0;
            });
          }
        });

        // (optionnel) réinitialiser quand la souris quitte le container
        el.addEventListener("mouseleave", () => {
          gsap.to(panels, {
            flex: 1,
            duration: 0.6,
            delay,
            ease: "power3.out",
          });
        });
      });
    }
  }

  revealLine() {
    const elts = document.querySelectorAll(".reveal-line");

    if (elts) {
      elts.forEach((el) => {
        SplitText.create(el, {
          type: "lines", // only split into words and lines (not characters)
          mask: "lines", // adds extra wrapper element around lines with overflow: clip (v3.13.0+)
          linesClass: "line++",
        });

        el.classList.add("ready");
      });
    }
  }

  inViewport() {
    // In viewport
    inView.offset({
      left: 0,
      bottom: window.innerHeight * 0.1,
    });
    inView(".js-reveal:not(.is-visible)")
      .on("enter", function (elt) {
        elt.dispatchEvent(new Event("inview"));
        elt.classList.add("is-visible");
        elt.classList.remove("not-visible");

        const video = elt.querySelector("video");

        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true") ||
          (video && video.dataset.autoplay == "true")
        ) {
          const v = video || elt;
          const playPromise = v.play();
          if (playPromise !== null) {
            playPromise.catch(() => {
              v.play();
            });
          }
        }
      })
      .on("exit", function (elt) {
        const video = elt.querySelector("video");
        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay != "") ||
          (video && video.dataset.autoplay != "")
        ) {
          const v = video || elt;
          v.pause();
        }

        elt.dispatchEvent(new Event("outview"));
        elt.classList.add("not-visible");
      });
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new App();
});
